import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line


import software from "../images/software.jpg"

import cloud from "../images/cloud.jpg"
import It from "../images/It.webp"

import MainFeature1 from "../components/features/TwoColWithButton";

import { SectionHeading as HeadingTitle } from "../components/misc/Headings";

import { ReactComponent as SvgDecoratorBlob3 } from "../images/svg-decorator-blob-3.svg";

import { ReactComponent as SvgDecoratorBlob1 } from "../images/svg-decorator-blob-4.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "../images/svg-decorator-blob-5.svg";

import "slick-carousel/slick/slick.css";

const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;
const HeadingInfoContainer = tw.div`flex flex-col items-center`;
const HeadingDescription = tw.p`mt-0 mb-8 font-medium text-gray-600 text-center max-w-screen-xl`;

const DecoratorBlob1 = tw(
  SvgDecoratorBlob1
)`absolute w-32 top-0 left-0 -z-10 text-primary-500 opacity-25 transform -translate-x-full`;
const DecoratorBlob2 = tw(
  SvgDecoratorBlob2
)`absolute w-32 bottom-0 right-0 -z-10 text-pink-500 opacity-15 transform translate-x-2/3 translate-y-8`;

const DecoratorBlob = styled(SvgDecoratorBlob3)`
  ${tw`pointer-events-none absolute right-0 bottom-0 w-64 opacity-25 transform translate-x-32 translate-y-48 `}
`;

const Container = tw.div`relative`;
export default () => {
  return (
    <AnimationRevealPage>
      <HeadingInfoContainer>
        <HeadingTitle tw="text-5xl mt-8 mb-4 font-black tracking-wide text-center">Our Services</HeadingTitle>
        <HeadingDescription>Aadi Info Solutions offers a comprehensive suite of services designed
          to meet the evolving needs of businesses across various industries.
          Our expertise spans software development, IT consulting, and cloud
          solutions, ensuring that we can provide tailored solutions that drive
          efficiency, innovation, and growth.
        </HeadingDescription>
      </HeadingInfoContainer>
    

      <Container>
        <DecoratorBlob />

        <MainFeature1
          subheading={false}
          heading="Software Development"
          description="We specialize in creating custom software solutions that align with your business objectives. Our team of skilled developers utilizes the latest technologies to build scalable, secure, and user-friendly applications. From web and mobile apps to enterprise systems, we deliver solutions that enhance productivity and streamline operations."
          buttonRounded={false}
          primaryButtonText={false}
          imageSrc={software}
        />
        <MainFeature1
          subheading={false}
          heading="Cloud Solutions"
          description="We help businesses leverage the power of the cloud to enhance scalability, flexibility, and cost-effectiveness. Our cloud solutions encompass migration, management, and optimization services, ensuring that your infrastructure is secure, reliable, and aligned with your evolving needs."
          buttonRounded={false}
          primaryButtonText={false}
          imageSrc={cloud}
          textOnLeft={false}
        />
        <MainFeature1
          subheading={false}
          heading="IT Consulting"
          description="Our IT consulting services provide strategic guidance to optimize your technology infrastructure. We assess your current systems, identify areas for improvement, and recommend solutions that align with your business goals. Our consultants work closely with your team to ensure seamless implementation and ongoing support."
          buttonRounded={false}
          primaryButtonText={false}
          imageSrc={It}
        />

        <DecoratorBlob1 />
        <DecoratorBlob2 />
      </Container>
    </AnimationRevealPage>
  );
};
